import BaseComponent from "../BaseComponent";
import TextInput from "components/Properties/InputComponents/TextInput";
import ToggleInput from "components/Properties/InputComponents/ToggleInput";

const VideoComponent = ({selectedObject, textOnChange, checkboxOnChange}) => {
  const videoSrc = selectedObject.userData.src;
  const isDoubleSide = selectedObject.userData.isDoubleSide || false;
  const isVideoMute = selectedObject.userData.isVideoMute || false;
  const isVideoAutoPlay = selectedObject.userData.isVideoAutoPlay || true;

  if (selectedObject.type === "Mesh" && selectedObject.userData.type === "video") {
    return (
      <BaseComponent title="Video" foldable={true}>
        <TextInput name="VideoSource" value={videoSrc} textOnChange={textOnChange} placeholder="Enter URL" />
        <ToggleInput name="DoubleSide" checked={isDoubleSide} checkboxOnChange={checkboxOnChange} />
        <ToggleInput name="VideoMute" checked={isVideoMute} checkboxOnChange={checkboxOnChange} />
        <ToggleInput name="AutoPlay" checked={isVideoAutoPlay} checkboxOnChange={checkboxOnChange} />
      </BaseComponent>
    );
  } else {
    return null;
  }
};

export default VideoComponent;
